import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/withJuno_logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-028beaaa")

_pushScopeId("data-v-028beaaa")
const _hoisted_1 = {
  id: "nav",
  class: "\n      flex\n      pt-5\n      pb-3\n      px-5\n      justify-between\n      flex-row\n      bg-screen\n      border-b-2 border-gray-100\n    "
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "withJuno"
}, null, -1)
const _hoisted_3 = { class: "flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SupportHelp = _resolveComponent("SupportHelp")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "flex logo",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
    }, [
      _hoisted_2
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_SupportHelp)
    ])
  ]))
})